export const SUNAT_DOC_CODES = {
  factura: '01',
  recibo_por_honorarios: '02',
  boleta: '03',
  nota_credito: '07',
  nota_debito: '08',
  otro: '00',
};

export const SUNAT_REVERSE_CODES = {
  '01': 'factura',
  '02': 'recibo_por_honorarios',
  '03': 'boleta',
  '07': 'nota_credito',
  '08': 'nota_debito',
  '00': 'otro',
};

export const SUNAT_DOC_LABELS = {
  factura: 'Factura',
  recibo_por_honorarios: 'Recibo por Honorarios',
  boleta: 'Boleta',
  nota_credito: 'Nota de Crédito',
  nota_debito: 'Nota de Débito',
  otro: 'Otro',
};

export function getSunatDocCode(type) {
  return SUNAT_DOC_CODES[type] || '00';
}

export function getSunatDocLabel(code) {
  const map = {
    '01': 'Factura',
    '02': 'Recibo por Honorarios',
    '03': 'Boleta',
    '07': 'Nota de Crédito',
    '08': 'Nota de Débito',
    '00': 'Otro',
  };
  return map[code] || code;
}

export function getSunatDocTypeKey(code) {
  return SUNAT_REVERSE_CODES[code] || 'otro';
}

export default { SUNAT_DOC_CODES, SUNAT_REVERSE_CODES, SUNAT_DOC_LABELS, getSunatDocCode, getSunatDocLabel, getSunatDocTypeKey };
